import { request } from '../utils/request'
import { stringify } from '../utils/index'
export default {
  setstaffrooms: (option) => request('v1/staffroom/setstaffrooms', option), // 设置鉴定人员房间
  getstaffrooms: (option) => request('v1/staffroom/getstaffrooms', option), // 获取鉴定人员房间
  syncordertoccicgroup20enable: (option) => request('v1/vendor/syncordertoccicgroup20enable' + stringify(option), option) // 是否启用订单同步
}
